import { render, staticRenderFns } from "./CompanyReports.vue?vue&type=template&id=4117837e"
import script from "./CompanyReports.vue?vue&type=script&lang=js"
export * from "./CompanyReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports